/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AttachLinkOffIcon16Light } from './AttachLinkOffIcon16Light';
import { AttachLinkOffIcon16Regular } from './AttachLinkOffIcon16Regular';
import { AttachLinkOffIcon16Solid } from './AttachLinkOffIcon16Solid';
import { AttachLinkOffIcon20Light } from './AttachLinkOffIcon20Light';
import { AttachLinkOffIcon20Regular } from './AttachLinkOffIcon20Regular';
import { AttachLinkOffIcon20Solid } from './AttachLinkOffIcon20Solid';
import { AttachLinkOffIcon24Regular } from './AttachLinkOffIcon24Regular';
import { AttachLinkOffIcon24Solid } from './AttachLinkOffIcon24Solid';
import { AttachLinkOffIcon32Regular } from './AttachLinkOffIcon32Regular';
import { AttachLinkOffIcon64Regular } from './AttachLinkOffIcon64Regular';
var sizes = {
    16: {
        light: AttachLinkOffIcon16Light,
        regular: AttachLinkOffIcon16Regular,
        solid: AttachLinkOffIcon16Solid,
    },
    20: {
        light: AttachLinkOffIcon20Light,
        regular: AttachLinkOffIcon20Regular,
        solid: AttachLinkOffIcon20Solid,
    },
    24: {
        regular: AttachLinkOffIcon24Regular,
        solid: AttachLinkOffIcon24Solid,
    },
    32: {
        regular: AttachLinkOffIcon32Regular,
    },
    64: {
        regular: AttachLinkOffIcon64Regular,
    },
};
export var AttachLinkOffIcon = forwardRef('AttachLinkOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
